<template>
  <div class="row no-gutters">

    <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-6">

      <div class="w-100">

        <div id="login-div">

          <div class="text-center">
            <img class="logo-img" :src="require(`@/assets/images/b122/logo.svg`)" alt="Logo Login">
          </div>

          <b-alert :show="showError" variant="danger" class="mt-4">{{ textError }}</b-alert>

          <b-alert :show="showSuccess" variant="success" class="mt-4">Votre nouveau mot de passe est bien enregistré.</b-alert>

          <div v-if="!showError && !showSuccess">
            <h1 class="mt-4">
              Choisissez votre nouveau mot de passe
            </h1>

            <form ref="form" @submit.stop.prevent="handleSubmit" class="mt-4">

              <!-- New password -->
              <b-form-group
                  label="Nouveau mot de passe"
                  label-for="newPassword-input"
                  :invalid-feedback="newPassword.invalidFeedback"
                  :state="newPassword.state"
              >
                <b-form-input
                    id="newPassword-input"
                    v-model="newPassword.value"
                    :state="newPassword.state"
                    type="password"
                    autocomplete="off"
                    required
                ></b-form-input>
              </b-form-group>

              <!-- New password repeat -->
              <b-form-group
                  label="Confirmer le nouveau mot de passe"
                  label-for="newPasswordRepeat-input"
                  :invalid-feedback="newPasswordRepeat.invalidFeedback"
                  :state="newPasswordRepeat.state"
              >
                <b-form-input
                    id="newPasswordRepeat-input"
                    v-model="newPasswordRepeat.value"
                    :state="newPasswordRepeat.state"
                    type="password"
                    autocomplete="off"
                    required
                ></b-form-input>
              </b-form-group>

              <div class="mt-4">
                <b-button type="submit" class="btn-block" variant="primary">Valider</b-button>
              </div>

            </form>
          </div>

        </div>

      </div>
    </div>

    <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-6 d-lg-block d-xl-block" :style="{'background-image': 'url(' + require(`@/assets/images/b122/login-background.png`) + ')'}">
    </div>

  </div>

</template>

<script>

import api from "../../services/api";

export default {

  name: "ChangePassword",

  data() {
    return {

      token: this.$route.params.token,

      showSuccess: false,
      showError: false,
      textError: "",

      newPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },

      newPasswordRepeat: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {

      let data = new FormData()
      data.append('token', this.token)

      api({
        method: 'POST',
        url: `/forgotPassword/checkUpdatePasswordToken`,
        data: data
      })
          .catch((error) => {
            if (error.response.status === 418) {
              this.textError = error.response.data.message
              this.showError = true
            }
          });
    },

    handleSubmit() {

      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('newPassword', this.newPassword.value.trim())
      formData.append('newPasswordRepeat', this.newPasswordRepeat.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/updatePasswordFromEmail`,
        data: formData
      })
          .then((response) => {
            this.showSuccess = true
            this.showError = false
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.textError = error.response.data.message
              this.showError = true
            } else {
              this.textError = "Erreur serveur."
              this.showError = true
            }
          });
    },


    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
      }
      this.newPassword.state = this.newPassword.value != null && this.newPassword.value.trim() !== ""
      this.newPassword.invalidFeedback = 'Ce champ est requis'
      this.newPasswordRepeat.state = this.newPasswordRepeat.value != null && this.newPasswordRepeat.value.trim() !== ""
      this.newPasswordRepeat.invalidFeedback = 'Ce champ est requis'
      if (this.newPassword.state && this.newPassword.value.length < 7) {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = "Votre mot de passe doit contenir au moins 7 caractères"
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = ''
        valid = false
      }
      if (this.newPassword.state && this.newPasswordRepeat.state && this.newPassword.value !== this.newPasswordRepeat.value) {
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = 'Le nouveau mot de passe ne correspond pas'
        valid = false
      }
      return valid
    },

  }

};
</script>

<style scoped>

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 100px;
  padding-left: 100px;
  height: 100vh;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none;
  }
}

@media (max-width: 500px) {
  #col-left-with-text {
    padding-right: 40px;
    padding-left: 40px;
  }
}

@media (max-height: 700px) {
  #col-left-with-text {
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}

.logo-img {
  max-height: 140px;
}

h1 {
  font-size: var(--title-level-one-font-size);
}

h2 {
  font-size: var(--title-level-two-font-size);
}

.forgot-password-link {
  color: var(--secondary-text-color);
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ChangePassword.vue